import { defineBlock, smartProps, BlockWrapper, ChildrenBlock, useEditor } from '@smartfire/js-block-engine';
import { EditableHeading, EditableText } from '@smartfire/components';
import { useMediaQuery } from 'react-responsive';
import style from './style.module.scss';

export const AnchorText = ({ title, mobileText }) => {
    const { isEditing } = useEditor();
    const isTablet = useMediaQuery({ query: '(max-width: ' + style.tabletBreakpoint + ')' });

    return (
        <BlockWrapper.Div className={style.block}>
            {((isTablet && title?.content) || isEditing) && (
                <EditableHeading className={style.title} smartProp="title" />
            )}
            {((isTablet && mobileText) || isEditing) && (
                <EditableText className={style.subtitle} smartProp="mobileText" tagName="p" />
            )}
            <ChildrenBlock
                gutenbergEditorConfig={{
                    allowedBlocks: ['core/anchor-text---anchor-part', 'smartfire/anchor-text---text-part'],
                    template: [['smartfire/anchor-text---anchor-part'], ['smartfire/anchor-text---text-part']],
                    templateLock: true,
                }}
                childrenProps={{ title: title?.content }}
                className={style.children}
            />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: AnchorText,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 1,
        }),
        mobileText: smartProps.string.withDefault('Retrouvez toutes les informations pour votre démarche'),
    },
    setup: {
        title: 'Ancres et texte',
    },
});
